class t{constructor(t,s,a){this.nodeAccountId=t,this.transactionId=s,this.signableTransactionBodyBytes=a}}export{t as default};
//# sourceMappingURL=SignableNodeTransactionBodyBytes.js.map
